<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter">
<p class="imaget"><a id="page_1"></a><img alt="illustration" src="images/part01.png"/><a id="page_2"></a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?c2a518f6